export default angular
  .module("ScriptListCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ScriptListController", [
    "$scope",
    "$timeout",
    "$location",
    "$state",
    "$modal",
    "$stateParams",
    "$http",
    "$rootScope",
    "$translate",
    "Scripts",
    function (
      $scope,
      $timeout,
      $location,
      $state,
      $modal,
      $stateParams,
      $http,
      $rootScope,
      $translate,
      Scripts,
    ) {
      // default script list view settings
      $scope.searchString = $rootScope.scriptListFilter;
      $scope.newrisk = {};
      $scope.newrisk.VALUE = "";
      $scope.sortScripts = [];
      $scope.sortScripts.column = "ID";
      $scope.sortScripts.direction = false; // descending direction
      $scope.currentPage = $rootScope.scriptListPage || 1;
      $scope.searchStatus = $rootScope.scriptListFilterStatus || "all";
      $rootScope.scriptPageSize = $rootScope.scriptPageSize || 20;

      // get scripts
      $scope.scripts = Scripts.getScripts;
      $scope.loading = Scripts.loading;
      Scripts.loadScripts($scope.searchStatus);

      const setPage = (page) => {
        $rootScope.scriptListPage = page;
        $scope.currentPage = page;
      };

      // If user changes "Search from" value in UI.
      $scope.searchFromChanged = function () {
        Scripts.loadScripts($scope.searchStatus);
        $rootScope.scriptListFilterStatus = $scope.searchStatus;
        setPage(1);
      };

      $scope.filterChanged = function () {
        $rootScope.scriptListFilter = $scope.searchString;
        setPage(1);
      };

      $scope.pageChanged = setPage;

      // Sets table sort according to COLUMN
      // Also toggles between ascending and descending
      $scope.changeSorting = function (column) {
        if ($scope.sortScripts.column == column) {
          $scope.sortScripts.direction = !$scope.sortScripts.direction;
        } else {
          $scope.sortScripts.column = column;
          $scope.sortScripts.direction = false;
        }
      };

      // user clicked a script and details are shown.
      $scope.openScriptURL = function (scriptID) {
        $location.path(`/script/${scriptID}`);
      };
    },
  ]);
